import React, { useState } from 'react'

import { HelpCircle as HelpCircleIcon } from 'react-feather'
import { Box, Typography } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'

import { BaseDialog } from 'components'

const QuestionTutorialDialog = ({ open, setOpen, onClose }) => {
  const [iframeLoaded, setIframeLoaded] = useState(false)

  return (
    <BaseDialog
      open={open}
      setOpen={setOpen}
      title={
        <Box display="flex" alignItems="center" flexDirection="row" gridGap={3}>
          <HelpCircleIcon size={20} />
          <Typography variant="h4">Tutorial</Typography>
        </Box>
      }
      actionButtonText="Fechar"
      actionButton={onClose}
    >
      <Box position="relative" width="100%" height="350px">
        {!iframeLoaded && (
          <Skeleton
            variant="rect"
            width="100%"
            height="100%"
            animation="wave"
          />
        )}
        <iframe
          title="Tutorial do Portal de Fornecedores"
          src="https://player.vimeo.com/video/1182048439?autoplay=1&loop=1&autopause=0"
          allow="autoplay; fullscreen"
          onLoad={() => setIframeLoaded(true)}
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            border: 0,
            display: iframeLoaded ? 'block' : 'none',
          }}
        ></iframe>
      </Box>
    </BaseDialog>
  )
}

export default QuestionTutorialDialog
